module.exports = __webpack_public_path__ + "img/item_image_6.b878b2de.jpg";